import React from "react";
import "./App.css";

const Landing = ({ onClick }) => {
  return (
    <div className="landing cosmic-bg" onClick={onClick}>
      {/* STARFIELD BACKGROUND */}
      <svg className="starfield" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
        <defs>
          <radialGradient id="nebula" cx="50%" cy="50%" r="75%">
            <stop offset="0%" stopColor="#6600ff" stopOpacity="0.1" />
            <stop offset="50%" stopColor="#000010" stopOpacity="0.9" />
            <stop offset="100%" stopColor="#000" stopOpacity="1" />
          </radialGradient>
        </defs>
        <rect width="100%" height="100%" fill="url(#nebula)" />
        <g fill="white" opacity="0.2">
          {Array.from({ length: 200 }).map((_, i) => (
            <circle
              key={i}
              cx={Math.random() * 100 + "%"}
              cy={Math.random() * 100 + "%"}
              r={Math.random() * 0.7 + 0.2}
            />
          ))}
        </g>
      </svg>

      {/* TEXT */}
      <div className="center-content">
        <h1 className="farmgod-title">FARMGOD FINANCE</h1>
        <h2 className="farmgod-subtitle">reborn</h2>
      </div>
    </div>
  );
};

export default Landing;
